import { PropsWithChildren } from "react";

function DebugComponent({children}: PropsWithChildren<{}>) {
    return <>{ children }</>;
}

export default DebugComponent;